import { useCallback, useMemo } from 'react';
import { Role, useSession } from '../../../lib/context/SessionContext';
import { MenuItemType, WithChildren } from '../../app/compound/Header/Header.types';

const isMenuWithChildren = (item: any): item is WithChildren<MenuItemType> => item.children !== undefined;

export const usePersonaMenuItems = <T extends WithChildren<MenuItemType> | MenuItemType>(items: T[]): T[] => {
  const { payload } = useSession();

  const filterItemsByRole = useCallback(
    ({ roles }: { roles: Role[] }): boolean => !roles.length || (!!payload?.role && roles.includes(payload?.role)),
    [payload],
  );

  return useMemo(
    () =>
      items.filter(filterItemsByRole).map(props => ({
        ...props,
        ...(isMenuWithChildren(props) ? { children: props.children.filter(filterItemsByRole) } : null),
      })),
    [payload],
  );
};
